import { Component, EventEmitter, inject, Output } from "@angular/core";
import { DashboardStore } from "../../../services/dashboard.store";
import { CommonModule } from "@angular/common";

const i18Cmp = "dashboard";
const i18CmpTotalPerformance = `${i18Cmp}.total_performance`;
const i18CmpTotalPerformanceItems = `${i18CmpTotalPerformance}.performance_items`;
const i18CmpDirectionLabel = `${i18CmpTotalPerformance}.direction`;

@Component({
  selector: "er-base-performance-items",
  templateUrl: "./base-performance-items.component.html",
  imports: [CommonModule],
  standalone: true,
})
export class BasePerformanceItemsComponent {
  @Output()
  public mouseenter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public mouseleave: EventEmitter<boolean> = new EventEmitter<boolean>();

  public readonly dashboardStore = inject(DashboardStore);

  public readonly i18Cmp = i18Cmp;
  public readonly i18CmpTotalPerformanceItems = i18CmpTotalPerformanceItems;
  public readonly i18CmpDirectionLabel = i18CmpDirectionLabel;

  public onMouseEnter() {
    this.mouseenter.emit(true);
  }

  public onMouseLeave() {
    this.mouseleave.emit(true);
  }
}
